import {
  BarcodeOutlined,
  DollarOutlined,
  FireOutlined,
  InsertRowAboveOutlined,
  NumberOutlined,
  ScissorOutlined,
} from '@ant-design/icons';
import Card from 'antd/es/card/Card';
import Avatar from 'antd/lib/avatar';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import Segmented from 'antd/lib/segmented';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import routesConfig from '../../../config/routes';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { UserProfile } from './UserProfile';
import { HeaderLinks } from './HeaderLinks';

export const gamesMenu = [
  {
    value: routesConfig.gameKnb,
    name: 'КНБ',
    icon: <ScissorOutlined />,
    disabled: false,
  },
  {
    value: routesConfig.gameHot,
    name: 'Орел-решка',
    icon: <DollarOutlined />,
    disabled: false,
  },
  { value: 'ms', name: 'Сапер', icon: <FireOutlined />, disabled: true },
  {
    value: 'gtn',
    name: 'Угадай число',
    icon: <BarcodeOutlined />,
    disabled: true,
  },
  { value: 'kres', name: 'Крестики', icon: <NumberOutlined />, disabled: true },
  {
    value: 'wsp',
    name: 'Морской бой',
    icon: <InsertRowAboveOutlined />,
    disabled: true,
  },
];

class _HeaderBlock extends Component<IRootStoreProps> {
  render() {
    const { user, navigation } = this.props.store;

    return (
      <Row gutter={8}>
        <Col span={17}>
          <Card bordered={false} style={{ marginBottom: 8 }}>
            <HeaderLinks gap="small" />
          </Card>
          <Card bordered={false}>
            <Segmented
              block
              disabled={!user.isAuth}
              value={navigation.location?.pathname}
              onChange={value => navigation.goToPage(value)}
              options={gamesMenu.map(i => ({
                label: (
                  <div style={{ padding: 4, paddingTop: 10 }}>
                    <Avatar size={50} style={{ backgroundColor: '#E55A53', borderRadius: 14 }} icon={i.icon} />
                    <div>{i.name}</div>
                  </div>
                ),
                value: i.value,
                disabled: i.disabled,
              }))}
            />
          </Card>
        </Col>
        <Col span={7}>
          <Card bordered={false}>
            <UserProfile />
          </Card>
        </Col>
      </Row>
    );
  }
}

export const HeaderBlock: WithoutStore = withStore(observer(_HeaderBlock));
